import gql from 'graphql-tag';

export default gql`
  mutation AUTH_UPDATE_LAST_LOGIN {
    authUpdateLastLogin
  }
`
